import React from "react";
import internet from "../../images/undraw_page_not_found_re_e9o6.svg"
import "./notfound.css";
const Notfound = () => {
  return (
    <div className="internet">
      <h2>هذة الصفحة غير موجودة </h2>

      <img src={internet} alt="internet" />
    </div>
  );
};

export default Notfound;
